// TODO: remove from `core-js@4`
var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

defineWellKnownSymbol('replaceAll');



// WEBPACK FOOTER //
// webpack://idx/node_modules/core-js-pure/modules/esnext.symbol.replace-all.js